import { memo } from 'react';

import FieldWrapper from '../FieldWrapper/FieldWrapper';
import { FieldsProps } from './Fields.types';

const Fields = memo<FieldsProps>((props) => {
    const { fields, formValues, setFormValues, validationErrors, setValidationErrors, setFieldsTouched } = props;

    return (
        <>
            {fields
                .filter((field) => field.enabled)
                .map((field) => (
                    <FieldWrapper
                        key={field.path}
                        field={field}
                        formValues={formValues}
                        setFormValues={setFormValues}
                        setFieldsTouched={setFieldsTouched}
                        validationErrors={validationErrors}
                        setValidationErrors={setValidationErrors}
                    />
                ))}
        </>
    );
});

export default Fields;
